import { render } from "./GridFazenda.vue?vue&type=template&id=1a823b20&scoped=true"
import script from "./GridFazenda.vue?vue&type=script&lang=js"
export * from "./GridFazenda.vue?vue&type=script&lang=js"

import "./GridFazenda.vue?vue&type=style&index=0&id=1a823b20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a823b20"]])

export default __exports__